
export const SYS_ORG_NAME = 'sys';

export const SYS_ADMIN_ROLE = 'sys_admin';
export const ORG_ADMIN_ROLE = 'org_admin';
export const RECSHARE_ADMIN_ROLE = 'recshare_admin';
export const DEPT_ADMIN_ROLE = 'dep_admin';
export const GBL_CHNL_ADMIN_ROLE = 'global_channel_admin';
export const CHNL_ADMIN_ROLE = 'channel_admin';
export const AUDITOR_ROLE = 'auditor';

export const ASSET_ROOT_FOLDER = '(根目錄)';

export const PLAYABLE_EXT = ['mp3', 'm4a', 'wav', 'flac', 'ogg', 'wma'];

export const ENABLE_API_DBG = process.env.VUE_APP_ENABELE_API_DBG === 'true' ? true : false
export const ROUTENAME = {
  HOME: '首頁',
  GBL: '全域',
  GBL_ORG: '單位管理',
  GBL_USER: '帳號管理',
  GBL_CHANNEL: '全域頻道管理',

  GBLCHNL: '全域頻道',
  GBLCHNL_ASSET: '全域內容管理',
  GBLCHNL_WHITELIST: '單位白名單管理',

  ORG: '單位',
  ORG_USER: '單位帳號管理',
  ORG_MBR: '人員管理',
  ORG_DEPT: '部門管理',
  ORG_CHNL: '頻道管理',
  ORG_EXTCHNL: '外部頻道管理',
  ORG_SHARE_CHNL: '頻道分享',
  ORG_IMPORT_MBR: '人員匯入',
  ORG_RECSHARE: '錄音流通管理',
  ORG_AUDIT: '音檔檢查員',

  RECSHARE: '錄音流通',
  RECSHARE_SETTING: '錄音流通設定',
  RECSHARE_MBR: '錄音流通成員',
  RECSHARE_ASSET: '錄音流通內容',
  RECSHARE_APPR: '流通審核',

  DEPT: '部門',
  DEPT_MBR: '成員管理',
  DEPT_GRP: '群組管理',
  DEPT_CHNL: '頻道瀏覽',
  DEPT_APPR: '訂閱審核',
  DEPT_GRANT: '部門授權管理',
  DEPT_LATEST: '最新音檔',

  CHNL: '頻道',
  CHNL_ASSET: '內容管理',
  CHNL_WHITELIST: '部門白名單管理',
  CHNL_GRANT: '頻道授權管理',
  ABOUT: '關於',
}

export const UPLOAD_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  CANCELLED: 'cancelled',
}

export const IMPORT_XLSX = {
  UPLOAD_WORKERS: 1,
  STATE: {
    INCORRECT: 1,
    FAIL: 2,
    SUCCEED: 3,
    READY: 4,
  },
  MSG: {
    RECSHARE_NAME_ERR: '錄音流通名稱未填寫',
    NAME_ERR: '名稱未填寫',
    DEPT_ERR: '部門不存在',
    RECSHARE_ERR: '群組未填寫',
    TO_UPLOAD: '待上傳',
    UPLOADED: '上傳成功',
  }
}

export const MAX_DUEDATE = 4102358400000;
export const NO_DATE = null;

export default {
  SYS_ORG_NAME,
  SYS_ADMIN_ROLE,
  ORG_ADMIN_ROLE,
  DEPT_ADMIN_ROLE,
  GBL_CHNL_ADMIN_ROLE,
  CHNL_ADMIN_ROLE,
  ENABLE_API_DBG,
  ROUTENAME,
  UPLOAD_STATE,
  PLAYABLE_EXT,
  IMPORT_XLSX,
  MAX_DUEDATE,
  NO_DATE,
  ASSET_ROOT_FOLDER,
};
